export const LaunchDarklyFlags = {
  EnableExprience3: "enable-expereince-3",
  enableQRLogin: "enableQRLogin",
  enableAdminFeatures: "enableAdminFeatures",
  EnableExperience3: "enableExpereince-3",
  enableWeighingScaleToggle: "enableWeighingScaleToggle",
  mobileNotificationFlag: "mobileNotificationFlag",
  enableSorting: "enableSorting",
  recipeOrdering: "recipe-ordering",
  enableBannerRecipes: "banner-recipes",
  bannerFireworks: "banner-fireworks",
  referralWithReviewContent: "referral-with-review-content",
  enableExperience3Mob: "enableExperience3Mob",
  enableFavouritesMob: "enableFavouritesMob",
  enableViewRecipeMob: "enableViewRecipeMob",
  algolia_search: "algolia-search",
  mobExternalLinks: "mobExternalLink",
  shouldShowBanner: "mobileAppDownloadBanner",
  ratingOptions: "ratingOptions",
  Internationalisation: "internationalisation",
  enableMealPlan: "meal_plan",
  mealPlanQuickOptions: "meal_plan_quick_options",
  syncup: "syncup",
  posthogSessionReplay: "posthog-session-replay",
  enableMealPlanChallenge: "meal_plan_challenge",
  requiresProvisioning: "requires_provisioning",
};

